import { Observer } from '@ckeditor/ckeditor5-engine';

/**
 * Observa eventos "load" en elementos <audio>/<video> dentro del editor.
 * - Dispara eventos específicos: "audioLoaded", "videoLoaded".
 * - Dispara un evento genérico: "recorderLoaded".
 * - Marca layoutChanged para asegurar refresco de UI.
 */
export default class RecorderLoadObserver extends Observer {
    /**
     * @inheritDoc
     */
    observe(domRoot) {
        this.listenTo(
            domRoot,
            'load',
            (event, domEvent) => {
                const domElement = domEvent.target;

                if (this._shouldIgnore(domElement)) {
                    return;
                }

                const tagName = domElement.tagName?.toLowerCase();

                if (tagName === 'video' || tagName === 'audio') {
                    this._fireEvents(domEvent, tagName);
                }
            },
            { useCapture: true } // Captura fase para mayor fiabilidad
        );
    }

    /**
     * @inheritDoc
     */
    stopObserving(domRoot) {
        this.stopListening(domRoot);
    }

    /**
     * Filtro para ignorar elementos irrelevantes.
     */
    _shouldIgnore(domElement) {
        if (!domElement || domElement.nodeType !== 1) {
            return true;
        }

        // Ignorar si no está en el contenido editable
        if (!domElement.closest('.ck-content')) {
            return true;
        }

        // Solo reaccionar si el <audio>/<video> está dentro de un <figure class="recorder">
        if (!domElement.closest('figure.recorder')) {
            return true;
        }

        return false;
    }

    /**
     * Dispara eventos personalizados.
     */
    _fireEvents(domEvent, type = 'recorder') {
        if (!this.isEnabled) return;

        this.document.fire('layoutChanged');
        this.document.fire(`${type}Loaded`, domEvent); // ej: "videoLoaded", "audioLoaded"
        this.document.fire('recorderLoaded', domEvent); // genérico
    }
}
